import React, { useEffect } from "react";
import "./N_plus.css";
import { Helmet } from "react-helmet";



import imgquienes_somosContenidoDigital from '../assets/img1_quienes_somos_contenido_digital.jpg';
import imagesello1 from '../assets/sello_de_calidad_img_contenido_digital_1.jpeg';
import imagesello2 from '../assets/sello_de_calidad_img_contenido_digital_2.jpeg';
import imagesello3 from '../assets/sello_de_calidad_img_contenido_digital_3.jpeg';
import imagesello4 from '../assets/sello_de_calidad_img_contenido_digital_4.jpeg';
import imagesello5 from '../assets/sello_de_calidad_img_contenido_digital_5.jpg';
import imagesello6 from '../assets/sello_de_calidad_img_contenido_digital_6.jpeg';
import imagesello7 from '../assets/sello_de_calidad_img_contenido_digital_7.jpeg';
import imagesello8 from '../assets/sello_de_calidad_img_contenido_digital_8.jpg';
import imagesello9 from '../assets/sello_de_calidad_img_contenido_digital_9.jpg';
import imagesello10 from '../assets/sello_de_calidad_img_contenido_digital_10.jpg';
import imagesello11 from '../assets/sello_de_calidad_img_contenido_digital_11.jpg';
import imgDerecho from '../assets/img11_quienes_somos_contenido_digital.jpeg';
import imgMarketing from '../assets/img10_quienes_somos_contenido_digital.jpeg';
import image12 from '../assets/img12_quienes_somos_contenido_digital.jpg';
import imgTrigo from '../assets/img_trigo_contenido_digital.jpeg';
import imgBio from '../assets/img_bio_contenido_digital.jpg';
import libroImg from '../assets/boton_2_contenido_digital_r.jpg';





const N_plus = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
            <Helmet>
                  <title>EduIALogic | eduialogic | Eduialogic | Transformamos la educación digital en Colombia</title>
                  <meta
                    name="description"
                    content="Virtualizamos contenidos educativos con pedagogía de calidad, tecnología ágil y producción de bajo costo para todos los niveles de formación."
                  />
                  <link rel="canonical" href="https://www.eduialogic.com/" />
            </Helmet>
    <section id="servicios" className="servicios-container">
      <div className="hero_2_1">
        <h2_1> 🛡️  11 Sellos de Calidad de EduIALogic</h2_1>
        
      </div>

      <br />
      <div className="hero_3">
        <p className="intro_1_1">
          💡 Ingeniería Pedagógica en EduIALogic .
        </p>
        <br />
        <p className="intro_2_2">
        En <strong>EduIALogic</strong>, la ingeniería pedagógica es el motor central de calidad y de nuestra promesa de valor que da forma a cada experiencia de aprendizaje. Diseñamos contenidos educativos digitales aplicando un enfoque científico, creativo y tecnopedagógico que garantiza que cada recurso tenga un impacto real en el aprendizaje.
        </p>
        <br />
        <br />
         <p className="intro_3_3">
         Son 11 nuestros sellos de calidad: 
        </p>


        <div>
          {[
            
            {
              img: imagesello1,
              titulo: "✅ Referente Internacional de Calidad: Quality Matters K‑12",
              text: "Nuestros contenidos digitales se desarrollan tomando como referente los 48 indicadores de la Rúbrica de Calidad Quality Matters K-12 (6.ª edición, 2025). No afirmamos certificación, pero sí alineación pedagógica con uno de los marcos más rigurosos del mundo. Haz click en la imágen para mayor información.",
              link: "https://rubrica-quality-matters--7dnuqfw.gamma.site/"
            },
            {
              img: imagesello2,
              titulo: "🔍 Alta originalidad - baja similitud",
              text: "Nuestros contenidos no superan el 25 % de similitud en Turnitin, y ese porcentaje responde únicamente al uso legítimo de términos técnicos, citas académicas y referencias científicas. Esto es posible gracias a nuestra política editorial rigurosa y pública, que asegura originalidad, trazabilidad y responsabilidad académica en cada recurso. Haz click en la imágen para mayor información.",
              link: "https://declaracion-de-originali-oupo703.gamma.site/"
            },
            {
              img: imagesello3,
              titulo:"🧠 Diseño Instruccional Alineado, Progresivo y Significativo",
              text: "Los 11 pasos del modelo R-Learning 360° aseguran una coherencia pedagógica total, al conectar de forma estructurada los objetivos de aprendizaje con las actividades, los recursos y la evaluación. Cada paso responde a una lógica instruccional intencionada que evita la improvisación y guía al estudiante, paso a paso, por un camino de aprendizaje progresivo, claro y significativo. Haz click en las imágenes para mayor información.",
              link: "https://www.eduialogic.com/VIDEO R LERNING PASOS DETALLADO.mp4"
            },
      
            {
              img: imagesello4,
              titulo: "💻 Tecnología Compatible y Accesible",

              text: "Los contenidos se entregan listos para integrarse a cualquier LMS (Moodle, Canvas, Blackboard) vía URL, iframe o SCORM. Sin necesidad de cambiar tu ecosistema. La plataforma que empleamos evoluciona hacia el cumplimiento de los estándares WCAG 2.1: navegación por teclado, lectores de pantalla, subtítulos y estructura semántica HTML. Haz click en la imágen para mayor información.",

              link: "https://nuestra-plataforma-de-co-rei5ngn.gamma.site/"
            },
            {
              img: imagesello5,
              titulo: "📚 Producción 100 % Original y Curada",
              text: "Creamos desde cero. No usamos materiales de terceros ni licencias Creative Commons. Cada recurso es exclusivo, con referencias académicas verificadas y libres de conflictos de copyright; se desarrolla  con base en fuentes científicas, académicas y literarias debidamente curadas y referenciadas. Esta práctica asegura autenticidad, trazabilidad y responsabilidad académica, evitando riesgos legales, incoherencias pedagógicas o dependencias externas."
            },
            {
              img: imagesello6,
              titulo: "🎨 Riqueza Pedagógica Integral por Asignatura",
              text: "Una asignatura digitalizada por EduIALogic se destaca por la riqueza de sus recursos. Cada asignatura, está compuesta por temáticas de estudio, páginas de texto disciplinar original, videos educativos, gráficos y/o imágenes ilustrativas, diagramas lógicos, podcasts académicos, fuentes científicas curadas y referenciadas con acceso directo en PDF, glosarios técnicos con 20 términos cada uno, preguntas reflexivas o de recordación, actividades autoevaluativas interactivas, talleres de análisis y fundamentación, estudios de caso con sus respectivas guías de análisis e historias ramificadas tipo simulación narrativa. Esta diversidad pedagógica no solo aporta variedad de formatos, sino profundidad conceptual, aplicabilidad práctica y una estructura instruccional alineada con estándares internacionales. Permite que cada estudiante acceda al conocimiento desde distintos enfoques y niveles cognitivos, facilitando la comprensión, la retención y la transferencia real del aprendizaje en entornos virtuales."
            },
            {
              img: imagesello7,
              titulo: "📈 Analíticas de seguimiento funcionales",
              text: "La plataforma que utilizamos permite visualizar métricas clave como vistas por sección, , tiempo de permanencia y clics, ofreciendo a docentes e instituciones un sistema de seguimiento pedagógico claro y accionable. A diferencia de los reportes complejos de SCORM, estas analíticas son intuitivas, visuales y centradas en el contenido, facilitando una evaluación formativa precisa y decisiones didácticas basadas en evidencia real del comportamiento del estudiante."
            },
            {
              img: imagesello8,
              titulo: "🔄 Accesibilidad Online y Offline",
              text: "Los estudiantes pueden descargar los contenidos en PDF, que incluyen textos, diagramas, gráficos y enlaces activos a videos y audios. Aunque los recursos audiovisuales requieren conexión para reproducirse, el diseño modular y el peso ligero de los archivos permiten su descarga con datos móviles, sin necesidad de anchos de banda elevados. Así, garantizamos continuidad en el aprendizaje incluso en contextos de baja conectividad."
            },
            {
              img: imagesello9,
              titulo: "🛠️ Actualización Continua como Compromiso de Calidad",
              text: "En EduIALogic brindamos soporte continuo para mantener actualizados los recursos clave de cada asignatura, especialmente los evaluativos, talleres, estudios de caso e historias ramificadas. Sabemos que la educación evoluciona, y por eso garantizamos que nuestros materiales no se vuelvan obsoletos. Este sello representa nuestro compromiso con la relevancia, la vigencia pedagógica y la mejora continua."
            },
            {
              img: imagesello10,
              titulo:"🤖 Ingenieros haciendo pedagogía, diseñando educación digital con propósito",
              text: "El uso de inteligencia artificial generativa nos permite acelerar la producción, enriquecer los formatos y personalizar los contenidos educativos sin perder el rigor académico. La diferencia está en cómo los usamos: no delegamos la pedagogía en la tecnología, sino que la potenciamos con ella. Nuestros ingenieros y tecnopedagogos trabajan juntos para crear materiales originales, estructurados y alineados con estándares de calidad. Este sello es garantía de que detrás de cada recurso hay una combinación estratégica de inteligencia humana, IA responsable y enfoque educativo, que da como resultado contenidos innovadores, funcionales y profundamente pedagógicos."
            },
            {
              img: imagesello11,
              titulo: "🤝 Acompañamiento Profesional y Ético",
              text: "Caminamos contigo desde el primer paso hasta la entrega final, y seguimos a tu lado en la actualización continua de cada recurso. Aportamos ética, claridad, soporte permanente y un compromiso genuino con la calidad educativa. Nuestra intención no es ofrecer un servicio puntual, sino convertirnos en aliados estratégicos de tu institución para fortalecer, evolucionar y escalar tu oferta virtual con rapidez, excelencia y resultados visibles. Porque la educación digital no necesita más velocidad sin sentido, sino producción ágil con calidad real."
            },
          
            ].map((sello, index) => (
              <div
                key={index}
                className={`sello-row ${index % 2 !== 0 ? "reverse" : ""}`}
              >
                <div className="sello-imagenes">
                  {sello.link ? (
                    <a
                      href={sello.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ cursor: index < 4 ? "pointer" : "default" }}
                    >
                      <img
                        src={sello.img}
                        alt={`Sello ${index + 1}`}
                        className={index < 4 ? "sello-img-hover" : ""}
                      />
                    </a>
                  ) : (
                    <img
                      src={sello.img}
                      alt={`Sello ${index + 1}`}
                      className={index < 4 ? "sello-img-hover" : ""}
                    />
                  )}
          
                  {/* 👇 Aquí insertamos la imagen extra SOLO en el tercer sello */}
                  {index === 2 && (
                    <a
                      href="/R LEARNING REGISTRADO P2025.pdf"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        src={libroImg}
                        alt="Ver documento PDF"
                        className="sello-img-extra"
                      />
                    </a>
                  )}
                </div>
          
                <div className="sello-texto">
                  <h4 className="sello-titulo">{sello.titulo}</h4>
                  {sello.text.split("\n").map((line, i) => (
                    <p key={i}>{line}</p>
                  ))}
                </div>
              </div>
            ))}
          </div>
          
        
         
          <br />
          <br />
        <p className="intro_2">
           ¿Quieres ver una asignatura digitalizada por nuestro equipo?
          </p>
          <br />
          <p className="intro_3">
           Estos son algunos ejemplos reales de asignaturas transformadas con R-Learning 360°: calidad, estructura y experiencia virtual completa en 11 pasos.
          </p>

          <div className="grid-cursos">
            <div className="curso-card">
              <img src={imgDerecho} alt="Derecho Penal" className="curso-img" />
              <h3>Derecho Penal</h3>
              <p>Asignatura de pregrado</p>
              <a
                href="https://gamma.app/docs/Derecho-Penal-General-l30reok9jr95d33"
                target="_blank"
                rel="noopener noreferrer"
                className="btn-modern"
              >
                Ver curso
              </a>
            </div>

            <div className="curso-card">
              <img src={imgMarketing} alt="Marketing Digital" className="curso-img" />
              <h3>Fundamentos del Marketing Digital</h3>
              <p>Asignatura de Maestría o de especialización</p>
              <a
                href="https://gamma.app/docs/Fundamentos-del-Marketing-Digital-th1wmg9rybb69a5"
                target="_blank"
                rel="noopener noreferrer"
                className="btn-modern"
              >
                Ver curso
              </a>
            </div>

            <div className="curso-card">
              <img src={imgTrigo} alt="Trigonometría" className="curso-img_1" />
              <h3>Geometría y Trigonometría</h3>
              <p>Asignatura de grado 11 de Bachillerato</p>
              <a
                href="https://gamma.app/docs/GEOMETRIA-Y-TRIGONOMETRIA-zwd7scg8rs6d77a"
                target="_blank"
                rel="noopener noreferrer"
                className="btn-modern"
              >
                Ver curso
              </a>
            </div>

            <div className="curso-card">
              <img src={imgBio} alt="Biología" className="curso-img_1" />
              <h3>Biología</h3>
              <p>Asignatura de grado quinto de Primaria</p>
              <a
                href="https://gamma.app/docs/BIOLOGIA-rahfqgx8u8tvcw7"
                target="_blank"
                rel="noopener noreferrer"
                className="btn-modern"
              >
                Ver curso
              </a>
            </div>
          </div>

          <br />
          <br />

          <h2>EduIALogic se pone la camiseta por tu institución.</h2>
          <p className="intro_3">
           ¡Juntos transformamos la educación, paso a paso!
          </p>
          <br />

           <div className="imagen-contenido-digital">
            <img src={image12} alt="Contenido Digital EduIALogic" />
          </div>
          

      </div>



    </section>
    </>
  );
};

export default N_plus;